(() => {
  'use strict';
  if (window.agoCartQuantityV1) return;
  const records = new Map();
  let totals = null;
  let frame = 0;
  let copy = { product: '[count] in cart, all options', variant: '[count] in cart for this option' };
  const normalId = value => String(value || '').split('/').pop();
  const resize = new ResizeObserver(() => schedule());
  const watched = new Set();
  const readProjection = scope => {
    const nodes = scope.querySelectorAll('script[data-ago-cart-quantities]');
    if (!nodes.length) return;
    try {
      const value = JSON.parse(nodes[nodes.length - 1].textContent);
      if (!Array.isArray(value.lines) || value.lines.length !== value.lineCount) { totals = null; return; }
      const products = new Map(), variants = new Map();
      for (const line of value.lines) {
        if (!Number.isSafeInteger(line.quantity) || line.quantity < 0) return;
        const product = normalId(line.productId), variant = normalId(line.variantId);
        if (!product || !variant) return;
        products.set(product, (products.get(product) || 0) + line.quantity);
        variants.set(variant, (variants.get(variant) || 0) + line.quantity);
      }
      totals = { products, variants };
    } catch (_) { return; }
  };
  const observe = node => {
    if (!watched.has(node)) { watched.add(node); resize.observe(node); }
  };
  const createBadge = host => {
    const badge = document.createElement('span');
    badge.className = 'ago-cart-quantity';
    badge.hidden = true;
    badge.setAttribute('role', 'img');
    badge.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 3h3l3 13h11l3-10H6"/><circle cx="9" cy="21" r="1"/><circle cx="19" cy="21" r="1"/></svg><span></span>';
    host.classList.add('ago-cart-quantity-host');
    host.appendChild(badge);
    observe(host);
    return badge;
  };
  const mount = () => {
    document.querySelectorAll('[data-ago-cart-product-id]').forEach(root => {
      const pdp = root.hasAttribute('data-ago-cart-pdp');
      const host = pdp ? root : root.querySelector('.product-image, .prs_slide_wrap');
      if (!host) return;
      let record = records.get(root);
      if (!record || record.host !== host || !record.badge.isConnected) {
        if (record) { record.badge.remove(); if (record.host !== host) { resize.unobserve(record.host); watched.delete(record.host); } }
        record = { host, badge: createBadge(host), pdp };
        records.set(root, record);
      }
    });
  };
  const render = () => {
    frame = 0;
    for (const node of watched) if (!node.isConnected) { resize.unobserve(node); watched.delete(node); }
    mount();
    records.forEach((record, root) => {
      if (!root.isConnected) { resize.unobserve(record.host); watched.delete(record.host); records.delete(root); return; }
      const { host, badge, pdp } = record;
      const variantInput = pdp ? document.querySelector(`form[action*="/cart/add"] [name="id"][data-productid="${normalId(root.dataset.agoCartProductId)}"]`) : null;
      const quantity = totals ? (pdp
        ? totals.variants.get(normalId(variantInput?.value || root.dataset.agoCartVariantId))
        : totals.products.get(normalId(root.dataset.agoCartProductId))) || 0 : 0;
      badge.hidden = !quantity;
      if (!quantity) return;
      const label = copy[pdp ? 'variant' : 'product'].replace('[count]', String(quantity));
      if (badge.getAttribute('aria-label') !== label) {
        badge.setAttribute('aria-label', label);
        badge.lastElementChild.textContent = quantity > 99 ? '99+' : String(quantity);
      }
      const rect = host.getBoundingClientRect();
      let top = rect.bottom - 8;
      root.querySelectorAll('[data-ago-image-bottom-label], .ago-clearance-card, [data-ago-first-unit-card-daily]').forEach(node => {
        if (node.closest('[data-ago-cart-product-id]') !== root) return;
        observe(node);
        const box = node.getBoundingClientRect();
        if (box.width > 0 && box.height > 0 && box.bottom <= rect.bottom + 2 && box.bottom > rect.top + rect.height / 2) {
          top = Math.min(top, box.top - 8);
        }
      });
      const bottom = Math.max(8, Math.ceil(rect.bottom - top));
      if (badge.style.bottom !== `${bottom}px`) badge.style.bottom = `${bottom}px`;
    });
  };
  function schedule() { if (!frame) frame = requestAnimationFrame(render); }
  const boot = () => {
    try { copy = { ...copy, ...JSON.parse(document.getElementById('AgoCartQuantityCopy')?.textContent || '{}') }; } catch (_) {}
    readProjection(document);
    schedule();
    new MutationObserver(changes => {
      let meaningful = false;
      changes.forEach(change => {
        if (change.target.closest?.('.ago-cart-quantity')) return;
        if (change.type === 'childList') {
          for (const node of change.addedNodes) {
            if (node.nodeType !== 1 || node.matches('.ago-cart-quantity')) continue;
            if (node.matches('script[data-ago-cart-quantities]')) readProjection(node.parentNode);
            else if (node.querySelector('script[data-ago-cart-quantities]')) readProjection(node);
            meaningful = true;
          }
          if (change.removedNodes.length) meaningful = true;
        } else if (change.target.closest?.('[data-ago-cart-product-id]') && !change.target.matches('.ago-cart-quantity-host')) meaningful = true;
      });
      if (meaningful) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    document.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
    const $ = window.jQuery_T4NT || window.jQuery;
    if ($) {
      // Read the existing selected-variant form after the theme handles the change.
      $(document).on('variant:change.agoCartQuantity', schedule);
      const requests = new WeakMap();
      let requested = 0, accepted = 0;
      $(document).ajaxSend((_, xhr, settings) => {
        if (/\/cart(?:\.js|\/|\?)/.test((settings && settings.url) || '')) requests.set(xhr, ++requested);
      });
      $(document).ajaxComplete((_, xhr) => {
        const sequence = requests.get(xhr);
        if (!sequence || sequence < accepted || xhr.status < 200 || xhr.status >= 300) return;
        let cart = xhr.responseJSON;
        if (!cart) { try { cart = JSON.parse(xhr.responseText); } catch (_) { return; } }
        // Existing confirmed Cart responses cover empty-cart updates that skip HTML fragments.
        if (!Array.isArray(cart?.items) || !Number.isInteger(cart.item_count)
          || cart.items.reduce((sum, item) => sum + item.quantity, 0) !== cart.item_count) return;
        const fragment = document.createElement('div');
        const seed = document.createElement('script');
        seed.setAttribute('data-ago-cart-quantities', '');
        seed.textContent = JSON.stringify({lineCount: cart.items.length, lines: cart.items.map(item => ({productId: item.product_id, variantId: item.variant_id, quantity: item.quantity}))});
        fragment.appendChild(seed);
        accepted = sequence;
        readProjection(fragment);
        schedule();
      });
    }
  };
  window.agoCartQuantityV1 = { version: 1 };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
